import { createContext, useContext } from 'react'

import { UseComboboxReturnValue } from 'downshift'

export type SearchableSelectContext<Item> = UseComboboxReturnValue<Item> & {
  disabled: boolean
  invalid: boolean
  autoFocus: boolean
}

export const SearchableSelectContext =
  createContext<SearchableSelectContext<unknown>>(undefined)

export const useSearchableSelect = () => {
  const context = useContext(SearchableSelectContext)
  if (context === undefined) {
    throw new Error(
      'useSearchableSelect must be used within a SearchableSelectProvider',
    )
  }
  return context
}
